import { SafeHtmlPipe } from './safe-html.pipe';
import {KeysPipe} from './keys.pipe'

export const Pipes = [
  SafeHtmlPipe,
  KeysPipe
];
